var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5212 3.59696C21.4148 3.55611 21.3125 3.5356 21.2142 3.5356C20.9932 3.5356 20.8092 3.61352 20.6618 3.76892L15.7142 8.7043V6.67865C15.7142 5.70457 15.3684 4.87192 14.6768 4.18026C13.9851 3.48869 13.1525 3.14288 12.1784 3.14288H3.53565C2.56178 3.14288 1.72895 3.48869 1.03725 4.18026C0.345807 4.87192 0 5.70457 0 6.67865V15.3215C0 16.2955 0.345807 17.1281 1.03729 17.8197C1.72899 18.5113 2.56182 18.8571 3.53569 18.8571H12.1785C13.1526 18.8571 13.9852 18.5113 14.6769 17.8197C15.3685 17.1281 15.7143 16.2955 15.7143 15.3215V13.2834L20.6619 18.2311C20.8093 18.3864 20.9933 18.4643 21.2143 18.4643C21.3126 18.4643 21.4149 18.4438 21.5213 18.4031C21.8406 18.2639 22.0001 18.0225 22.0001 17.6788V4.32147C22 3.97756 21.8405 3.73616 21.5212 3.59696Z",
    fill: "#4B9BF5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCall);
export default __webpack_public_path__ + "static/media/video-call.f7061ac8f70a9b01b7f308b2720986de.svg";
export { ForwardRef as ReactComponent };